module.exports = __webpack_public_path__ + "img/slim.6419631b.png";